import { fillArray } from 'src/helpers/fillArray'

import {
  TABLE_CELLS,
  TABLE_ROWS,
} from 'src/features/SkeletonForFavorites/constants'

export const useSkeletonForFavorites = () => {
  const rows = fillArray(TABLE_ROWS)
  const cells = fillArray(TABLE_CELLS)

  return { rows, cells }
}
